//import Swal from "sweetalert2";
//import Vue from "vue";
//import store from '../../state/store';

import {
    addBasket,
    addBasketCategory,
    addStockBasket,
    deleteBasket,
    deleteBasketCategory,
    deleteStockBasket,
    getBasketCategoryList,
    getBasketCategorySingle,
    getBasketList,
    getBasketSingle,
    getStockBasketList,
    getStockBasketSingle,
    updateBasket,
    updateBasketCategory,
    updateStockBasket,
} from "../../services/modules/basket/basketService.js";
import {
    showProcessErrorMessage,
    showProcessPromptMessage,
    showProcessSuccessMessage,
} from "../alertHelpers.js";

export const state = {
    basketCategoryList: [],
    basketList: [],
    basketListHeaders: [],
    basketListLoading: false,
    basketCategoryListHeaders: [],
    stockBasketList: [],
    stockBasketListHeaders: [],
    stockBasketListLoading: false,
    noBasketMessage: "",
    noStockMessage: "",
    stockBasketListCount: 0,
};

export const mutations = {
    setBasketCategoryList(state, data) {
        state.basketCategoryList = data;
    },
    setBasketCategoryListHeaders(state, data) {
        state.basketCategoryListHeaders = data;
    },
    setBasketList(state, data) {
        state.basketList = data;
    },
    setBasketListHeaders(state, data) {
        state.basketListHeaders = data;
    },
    setBasketListLoading(state, data) {
        state.basketListLoading = data;
    },
    setStockBasketList(state, data) {
        state.stockBasketList = data;
    },
    setStockBasketListHeaders(state, data) {
        state.stockBasketListHeaders = data;
    },
    setStockBasketListLoading(state, data) {
        state.stockBasketListLoading = data;
    },
    setNoBasketMessage(state, data) {
        state.noBasketMessage = data;
    },
    setNoStockMessage(state, data) {
        state.noStockMessage = data;
    },
    setStockBasketListCount(state,data) {
        state.stockBasketListCount = data;
    }
};

export const getters = {};

export const actions = {
    async fetchBasketCategoryList(context, {params, body}) {
        context.commit("setBasketCategoryListHeaders", [
            {
                key: "name",
                label: "Kategori Adı",
                sortable: false,
            },
            {
                key: "isActive",
                label: "Durum",
                sortable: true,
            },
            {
                key: "process",
                label: "İşlem",
                sortable: false,
                class: "text-center",
            },
        ]);
        let result = await getBasketCategoryList(params, body);
        context.commit("setBasketCategoryList", result.data.data);
        return result;
    },

    async fetchSingle(context, {params, body, urlSegments}) {
        context;
        let result = await getBasketCategorySingle(params, body, urlSegments);
        return result;
    },

    async basketCategoryAdd(context, {params, body}) {
        context;
        let result = await addBasketCategory(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchBasketCategoryList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async basketCategoryUpdate(context, {params, body}) {
        context;
        let result = await updateBasketCategory(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchBasketCategoryList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async basketCategoryDelete(context, {params, body}) {
        context;
        showProcessPromptMessage({
            title: "Sepet Kategorisi Silinecek",
            text:
                "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await deleteBasketCategory(params, body);
                if (result.data.success) {
                    showProcessSuccessMessage({
                        title: "İşlem Başarılı",
                        text: result.data.message,
                    }).then(() => {
                        context.dispatch("fetchBasketCategoryList", {
                            params: {},
                            body: {},
                        });
                    });
                } else
                    showProcessErrorMessage({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    });

                return result;
            }
        });
    },

    async fetchBasketList(context, {params, body}) {
        context.commit("setBasketListHeaders", [
            {
                key: "code",
                label: "Sepet Kodu",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "definition",
                label: "Açıklama",
                sortable: false,
                class: "text-left align-middle"

            },
            {
                key: "startDate",
                label: "Başlangıç Tarihi",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "finishDate",
                label: "Bitiş Tarihi",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "stockFreePercentage",
                label: "Stok / Bedelsiz",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "isActive",
                label: "Durum",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "process",
                label: "İşlem",
                sortable: false,
                class: "text-center align-middle"

            },
        ]);
        context.commit("setBasketListLoading", true);
        let result = await getBasketList(params, body);
        context.commit("setBasketListLoading", false);
        if (result.data.success) {
            context.commit("setBasketList", result.data.data);
        } else {
            context.commit("setNoBasketMessage", result.data.message);
            context.commit("setBasketList", []);
        }

        return result;
    },

    async basketAdd(context, {params, body}) {
        context;
        let result = await addBasket(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async basketUpdate(context, {params, body}) {
        context;
        let result = await updateBasket(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async stockBasketAdd(context, {params, body}) {
        context;
        let result = await addStockBasket(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async stockBasketUpdate(context, {params, body}) {
        context;
        let result = await updateStockBasket(params, body);
        return result;
    },

    async stockBasketDelete(context, {params, body}) {
        context;

        showProcessPromptMessage({
            title: "Stok Sepeti Silinecek",
            text:
                "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await deleteStockBasket(params, body);
                if (result.data.success) {
                    showProcessSuccessMessage({
                        title: "İşlem Başarılı",
                        text: result.data.message,
                    })
                } else{
                    showProcessErrorMessage({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    });
                }
                location.reload();
                return result;
            }
        });
    },

    async basketDelete(context, {params, body, urlSegments}) {
        context;

        showProcessPromptMessage({
            title: "Sepet Kampanyası Silinecek",
            text:
                "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await deleteBasket(params, body, urlSegments);
                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: "İşlem Başarılı",
                        text: result.data.message,
                    })
                } else
                    await showProcessErrorMessage({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    });
                location.reload();
                return result;
            }
        });
    },

    async fetchStockBasketList(context, {params, body}) {
        context.commit("setStockBasketListLoading", true);
        let result = await getStockBasketList(params, body);
        context.commit("setStockBasketListLoading", false);
        context.commit("setStockBasketListHeaders", [
            {
                key: "description",
                label: "Açıklama",
                sortable: false,
                class: "text-left align-middle"
            },
            {
                key: "dateRange",
                label: "Tarih Aralığı",
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: "currentType",
                label: "Cari Tipi",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "currentKey",
                label: "Cari Veri",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "stockType",
                label: "Stok Tipi",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "stockKey",
                label: "Stok Veri",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "valueKey1",
                label: "İskonto Oran",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "valueKey2",
                label: "İskonto Oran 2",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "isActive",
                label: "Durum",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "process",
                label: "İşlem",
                sortable: false,
                class: "text-center align-middle"

            },
        ]);
        context.commit("setStockBasketListCount", result.data.totalCount);
        if (result.data.success) {
            context.commit("setStockBasketList", result.data.data);
        } else {
            context.commit("setStockBasketList", []);
            context.commit("setNoStockMessage", result.data.message);
        }

        return result;
    },

    async fetchStockBasketSingle(context, {params, body}) {
        let result = await getStockBasketSingle(params, body);
        if (result.data.success) return result.data.data;
        else return null;
    },

    async fetchBasketSingle(context, {params, body}) {
        context;
        let result = await getBasketSingle(params, body);
        if (result.data.success) return result.data.data;
        else return null;
    },
};
